/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsPreDraftModeSchema } from "../DTOs/preDraftModeSchema.ts";
import { goodLuckCoreDTOsPreDraftTimeoutActionSchema } from "../DTOs/preDraftTimeoutActionSchema.ts";
import { goodLuckCoreEntitiesArenaAssemblyStateSchema } from "./arenaAssemblyStateSchema.ts";
import { goodLuckCoreEntitiesArenaGameSchema } from "./arenaGameSchema.ts";
import { goodLuckCoreEntitiesArenaTeamModeSchema } from "./arenaTeamModeSchema.ts";
import { goodLuckCoreEntitiesBracketSchema } from "./bracketSchema.ts";
import { goodLuckCoreEntitiesBracketTypeSchema } from "./bracketTypeSchema.ts";
import { goodLuckCoreEntitiesDraftOrderModeSchema } from "./draftOrderModeSchema.ts";
import { goodLuckCoreEntitiesDraftPlayerSchema } from "./draftPlayerSchema.ts";
import { goodLuckCoreEntitiesDraftTeamSchema } from "./draftTeamSchema.ts";
import { goodLuckCoreEntitiesDraftTypeSchema } from "./draftTypeSchema.ts";
import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { goodLuckCoreEntitiesRegistrationApprovalModeSchema } from "./registrationApprovalModeSchema.ts";
import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTournamentFormatSchema } from "./tournamentFormatSchema.ts";
import { goodLuckCoreEntitiesTournamentModeratorSchema } from "./tournamentModeratorSchema.ts";
import { goodLuckCoreEntitiesTournamentRegistrationSchema } from "./tournamentRegistrationSchema.ts";
import { goodLuckCoreEntitiesTournamentRulebookSchema } from "./tournamentRulebookSchema.ts";
import { goodLuckCoreEntitiesTournamentStatsModeSchema } from "./tournamentStatsModeSchema.ts";
import { goodLuckCoreEntitiesTournamentStatusSchema } from "./tournamentStatusSchema.ts";
import { goodLuckCoreEntitiesTournamentTimelineModeSchema } from "./tournamentTimelineModeSchema.ts";
import { goodLuckCoreEntitiesTournamentTimelineStageSchema } from "./tournamentTimelineStageSchema.ts";
import { goodLuckCoreEntitiesTournamentTypeSchema } from "./tournamentTypeSchema.ts";
import { goodLuckCoreEntitiesTournamentWaitlistEntrySchema } from "./tournamentWaitlistEntrySchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { goodLuckCoreEntitiesWaitlistModeSchema } from "./waitlistModeSchema.ts";
import { goodLuckCoreEntitiesWaitlistPriorityRuleSchema } from "./waitlistPriorityRuleSchema.ts";
import { goodLuckCoreEntitiesWinnerPromotionModeSchema } from "./winnerPromotionModeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentSchema = z.object({
  id: z.string().nullish(),
  name: z.string().min(1),
  slug: z.string().max(200).nullish(),
  description: z.string().nullish(),
  officialStreamChannel: z.string().max(50).nullish(),
  showPlayerStreamers: z.optional(z.boolean()),
  showOfficialStream: z.optional(z.boolean()),
  bannerUrl: z.string().nullish(),
  rules: z.string().nullish(),
  region: z.string().nullish(),
  creatorId: z.string().nullish(),
  get creator() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get teams() {
    return z.array(goodLuckCoreEntitiesRosterSchema).nullish();
  },
  organizationId: z.optional(z.uuid()),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
  get type() {
    return goodLuckCoreEntitiesTournamentTypeSchema.optional();
  },
  get format() {
    return goodLuckCoreEntitiesTournamentFormatSchema.optional();
  },
  get bracketType() {
    return goodLuckCoreEntitiesBracketTypeSchema.optional();
  },
  enableThirdPlaceMatch: z.optional(z.boolean()),
  enableGrandFinal: z.optional(z.boolean()),
  startTimeTentative: z.optional(z.boolean()),
  prizePool: z.number().nullish(),
  prizeDescription: z.string().max(2000).nullish(),
  prizeDistributionJson: z.string().max(4000).nullish(),
  maxPlayers: z.int().nullish(),
  minRequiredRank: z.string().max(32).nullish(),
  enableCheckIn: z.optional(z.boolean()),
  checkInWindowMinutes: z.optional(z.int()),
  checkInStartTime: z.iso.datetime().nullish(),
  checkInEndTime: z.iso.datetime().nullish(),
  registrationOpenBeforeDays: z.optional(z.int()),
  registrationCloseBeforeMinutes: z.optional(z.int()),
  requireRiotAccount: z.optional(z.boolean()),
  allowReplayRosterMatching: z.optional(z.boolean()),
  get statsMode() {
    return goodLuckCoreEntitiesTournamentStatsModeSchema.optional();
  },
  autoStartMatches: z.optional(z.boolean()),
  defaultBestOf: z.optional(z.int()),
  finalBestOf: z.optional(z.int()),
  get preDraftMode() {
    return goodLuckCoreDTOsPreDraftModeSchema.optional();
  },
  disabledChampionIds: z.string().nullish(),
  get preDraftTimeoutAction() {
    return goodLuckCoreDTOsPreDraftTimeoutActionSchema.optional();
  },
  preDraftTurnSeconds: z.optional(z.int()),
  minTeamSize: z.int().nullish(),
  maxTeamSize: z.int().nullish(),
  enableRiotIntegration: z.optional(z.boolean()),
  riotTournamentProviderId: z.string().nullish(),
  riotTournamentId: z.string().nullish(),
  enableDiscordIntegration: z.optional(z.boolean()),
  discordGuildId: z.string().nullish(),
  discordCategoryId: z.string().nullish(),
  discordNewsChannelId: z.string().nullish(),
  discordNewsChannelPublicReadOnly: z.optional(z.boolean()),
  discordDraftRoleId: z.string().nullish(),
  discordCaptainRoleId: z.string().nullish(),
  discordInMatchRoleId: z.string().nullish(),
  discordWinnerRoleId: z.string().nullish(),
  discordStreamerRoleId: z.string().nullish(),
  discordModeratorRoleId: z.string().nullish(),
  allowCoachesInChannels: z.optional(z.boolean()),
  allowSubstitutesInChannels: z.optional(z.boolean()),
  allowStreamersInChannels: z.optional(z.boolean()),
  allowWebModeratorsInChannels: z.optional(z.boolean()),
  autoSendMatchStart: z.optional(z.boolean()),
  autoSendBracketProgress: z.optional(z.boolean()),
  autoSendRegistrationClose: z.optional(z.boolean()),
  discordBracketChannelId: z.string().nullish(),
  broadcastBracketToDiscord: z.optional(z.boolean()),
  discordBracketMessageId: z.string().nullish(),
  bracketImageVersion: z.optional(z.int()),
  discordRegCountMessageId: z.string().nullish(),
  get winnerPromotionMode() {
    return goodLuckCoreEntitiesWinnerPromotionModeSchema.optional();
  },
  matchStartDeadlineEnabled: z.optional(z.boolean()),
  useDynamicSchedule: z.optional(z.boolean()),
  roundBufferMinutes: z.int().nullish(),
  draftBudget: z.int().nullish(),
  draftRankCostsJson: z.string().nullish(),
  get draftType() {
    return goodLuckCoreEntitiesDraftTypeSchema.optional();
  },
  get draftOrderMode() {
    return goodLuckCoreEntitiesDraftOrderModeSchema.optional();
  },
  maxTeamsInDraft: z.int().nullish(),
  arenaTeamCount: z.optional(z.int()),
  arenaGamesCount: z.optional(z.int()),
  arenaScoringJson: z.string().max(500).nullish(),
  get arenaTeamMode() {
    return goodLuckCoreEntitiesArenaTeamModeSchema.optional();
  },
  arenaLobbyCount: z.optional(z.int()),
  get arenaAssemblyState() {
    return goodLuckCoreEntitiesArenaAssemblyStateSchema.optional();
  },
  arenaCurrentRound: z.optional(z.int()),
  arenaTasksDocUrl: z.string().max(500).nullish(),
  isDraftStarted: z.optional(z.boolean()),
  isDraftCompleted: z.optional(z.boolean()),
  draftStartTime: z.iso.datetime().nullish(),
  draftStartAt: z.iso.datetime().nullish(),
  draftStartedAt: z.iso.datetime().nullish(),
  draftLobbyOpenedAtUtc: z.iso.datetime().nullish(),
  draftCheckInNotifiedAtUtc: z.iso.datetime().nullish(),
  startReminderEmailSentAtUtc: z.iso.datetime().nullish(),
  announcementEmailSentAtUtc: z.iso.datetime().nullish(),
  publishedAtUtc: z.iso.datetime().nullish(),
  resultsEmailSentAtUtc: z.iso.datetime().nullish(),
  isTestTournament: z.optional(z.boolean()),
  currentDraftRound: z.int().nullish(),
  currentPickingTeamId: z.string().nullish(),
  isDraftBlocked: z.optional(z.boolean()),
  draftBlockedReason: z.string().nullish(),
  draftBlockedAtUtc: z.iso.datetime().nullish(),
  draftPickTimeoutSeconds: z.int().nullish(),
  draftTimeoutAction: z.string().nullish(),
  draftNoPickAction: z.string().nullish(),
  isDraftPaused: z.optional(z.boolean()),
  isDraftPausedByAdmin: z.optional(z.boolean()),
  draftPausedReason: z.string().nullish(),
  draftPausedAtUtc: z.iso.datetime().nullish(),
  draftPausedByUserId: z.string().nullish(),
  currentPickingTeamSinceUtc: z.iso.datetime().nullish(),
  get registrationApprovalMode() {
    return goodLuckCoreEntitiesRegistrationApprovalModeSchema.optional();
  },
  customRegistrationFieldsJson: z.string().max(4000).nullish(),
  waitlistEnabled: z.optional(z.boolean()),
  get waitlistMode() {
    return goodLuckCoreEntitiesWaitlistModeSchema.optional();
  },
  get waitlistPriorityRule() {
    return goodLuckCoreEntitiesWaitlistPriorityRuleSchema.optional();
  },
  get status() {
    return goodLuckCoreEntitiesTournamentStatusSchema.optional();
  },
  startDate: z.iso.datetime().nullish(),
  endDate: z.iso.datetime().nullish(),
  bracketPublishReminderSentAtUtc: z.iso.datetime().nullish(),
  pastEndDateWarningSentAtUtc: z.iso.datetime().nullish(),
  yellowCardsBeforeDisqualification: z.int().nullish(),
  redCardsBeforeDisqualification: z.int().nullish(),
  pausesAllowedPerMatch: z.optional(z.int()),
  pauseDurationMinutes: z.optional(z.int()),
  scheduleDays: z.string().nullish(),
  createdById: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  disputeBlockNotifiedAtUtc: z.iso.datetime().nullish(),
  get createdBy() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get registrations() {
    return z.array(goodLuckCoreEntitiesTournamentRegistrationSchema).nullish();
  },
  get draftPlayers() {
    return z.array(goodLuckCoreEntitiesDraftPlayerSchema).nullish();
  },
  get draftTeams() {
    return z.array(goodLuckCoreEntitiesDraftTeamSchema).nullish();
  },
  get brackets() {
    return z.array(goodLuckCoreEntitiesBracketSchema).nullish();
  },
  get arenaGames() {
    return z.array(goodLuckCoreEntitiesArenaGameSchema).nullish();
  },
  get moderators() {
    return z.array(goodLuckCoreEntitiesTournamentModeratorSchema).nullish();
  },
  get waitlistEntries() {
    return z.array(goodLuckCoreEntitiesTournamentWaitlistEntrySchema).nullish();
  },
  get rulebook() {
    return goodLuckCoreEntitiesTournamentRulebookSchema.optional();
  },
  get timelineStages() {
    return z.array(goodLuckCoreEntitiesTournamentTimelineStageSchema).nullish();
  },
  currentTimelineStageId: z.string().nullish(),
  get timelineMode() {
    return goodLuckCoreEntitiesTournamentTimelineModeSchema.optional();
  },
});
